import VehicleFilter from '../../components/vehicles/VehiclesFilter'
import { connect } from 'react-redux'
import { IApplyFilters, IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState) {
  return {}
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleFilter)



// WEBPACK FOOTER //
// ./src/containers/vehicles/VehicleFilter.ts